import {BetterBusinessBureau, TrustPilot} from '@optimaxdev/icons';

import {REVIEWS_POPUPS} from 'constants/popupNames';

import * as GoogleLogo from 'mobile/pages/success/components/successPageForGlassesRedesign/assets/icons/google.svg';

import * as Bizrate from './img/bizrateBlack.svg';
import * as ResellerRating from './img/resellerBlack.svg';
import * as SiteJabber from './img/siteJabber.svg';

export type ButtonType = {
    id: string;
    icon: typeof import('*.svg');
    eventLabel: string;
};

export type LinkType = {
    eventLabel: string;
    icon: typeof import('*.svg');
    link: string;
    id: string;
};

export const REVIEW_PROVIDERS_SHOWED_ONCE: string[] = [
    REVIEWS_POPUPS.RESELLER,
    REVIEWS_POPUPS.BIZRATE,
    REVIEWS_POPUPS.SITEJABBER,
];

export const popupLinkConstants: Record<string, LinkType> = {
    [REVIEWS_POPUPS.BBB]: {
        eventLabel: 'BBB',
        icon: BetterBusinessBureau,
        id: REVIEWS_POPUPS.BBB,
        link: 'https://www.bbb.org/us/ny/new-york/profile/retail-optical-goods/glassesusa-0121-107236/customer-reviews#leave-a-review',
    },
    [REVIEWS_POPUPS.GOOGLE]: {
        eventLabel: 'Google business',
        icon: GoogleLogo,
        id: REVIEWS_POPUPS.GOOGLE,
        link: 'https://www.google.com/maps/place//data=!4m3!3m2!1s0x89c2590e58552505:0xeab69a586c7468cc!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2',
    },
};

export const popupButtonConstants: Record<string, ButtonType> = {
    [REVIEWS_POPUPS.BIZRATE]: {
        eventLabel: 'Bizrate',
        icon: Bizrate,
        id: REVIEWS_POPUPS.BIZRATE,
    },
    [REVIEWS_POPUPS.RESELLER]: {
        eventLabel: 'Reseller',
        icon: ResellerRating,
        id: REVIEWS_POPUPS.RESELLER,
    },
    [REVIEWS_POPUPS.SITEJABBER]: {
        eventLabel: 'Sitejabber',
        icon: SiteJabber,
        id: REVIEWS_POPUPS.SITEJABBER,
    },
    [REVIEWS_POPUPS.TRUST_PILOT]: {
        eventLabel: 'Trust pilot',
        icon: TrustPilot,
        id: REVIEWS_POPUPS.TRUST_PILOT,
    },
};
